import { CloSystemInfrastructures } from "../types/clo-managers/CloSystemInfrastructures";
import { arrayUtils } from "./array.utils";

export const groupCloSystemInfrastructure = (items: CloSystemInfrastructures[]) => {
    return arrayUtils.groupBy(items, i => i.type);
}

export const getCloSystemInfrastructureNamesList = (items: CloSystemInfrastructures[]) => items.map(i => i.name).join(', ')
